import { faFileLines } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import { getSelectedFundsManagerTitle } from '!views/Market/Funds/redux';
import { getSelectedTitle } from '!views/Market/StockExchange/marketStockExchange.seletors';
import { getActiveMenuItemSelector, menusSlice } from '»components/Menus';

import { trlDetailsServices } from './trlDetails.services';
import {
  ButtonLink,
  FileIconStyled,
  TableBodyStyled,
  TableCellStyled,
  TableHeadStyled,
  TableRowStyled,
  Tables,
  TableStyled,
  Wraper,
} from './TrlDetails.styles';

export const DocumentsList = ({ isFunds }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [tradeData, setTradeData] = useState([]);

  const selectedFund = useSelector(getSelectedFundsManagerTitle);
  const selectedTitleStockMarket = useSelector(getSelectedTitle);

  const selectedTitle = isFunds ? selectedFund : selectedTitleStockMarket;

  const activeMenuItem = useSelector(getActiveMenuItemSelector);
  const rows = [];

  for (let i = 6; i > tradeData.length; i--) {
    rows.push(
      <TableRowStyled key={i}>
        <TableCellStyled sx={{ textAlign: 'left', width: '80%' }} />
      </TableRowStyled>,
    );
  }

  const callService = async (a, b, c) => {
    const response = await trlDetailsServices.DetaisService({
      symbol: a,
      exchange: b,
      securityType: c,
    });

    response.forEach((doc) => {
      setTradeData([]);
      if (doc.documentId) callDocs(doc.documentId);
    });
  };

  const callDocs = async (a) => {
    const response = await trlDetailsServices.FilesService({ noteId: a });
    setTradeData(response);
  };

  const openProofPreview = (noteAttachId, fileName) => {
    if (activeMenuItem === 'MARKET:BOLSA') {
      navigate('/Market/StockExchange/ProofPreview', {
        state: { fileId: noteAttachId, fileName },
      });

      dispatch(
        menusSlice.actions.setActiveMenuItem({
          activeMenuItem: 'MARKET:BOLSA:PROOF',
        }),
      );
    } else if (activeMenuItem === 'MARKET:FUNDS') {
      navigate('/Market/Funds/ProofPreview', {
        state: { fileId: noteAttachId, fileName },
      });

      dispatch(
        menusSlice.actions.setActiveMenuItem({
          activeMenuItem: 'MARKET:FUNDS:PROOF',
        }),
      );
    } else if (activeMenuItem === 'MARKET:FUNDS:DETAILS') {
      navigate('/Market/Funds/Details/ProofPreview', {
        state: { fileId: noteAttachId, fileName },
      });

      dispatch(
        menusSlice.actions.setActiveMenuItem({
          activeMenuItem: 'MARKET:FUNDS:DETAILS:PROOF',
        }),
      );
    } else {
      navigate('/Market/StockExchange/Details/ProofPreview', {
        state: { fileId: noteAttachId, fileName },
      });

      dispatch(
        menusSlice.actions.setActiveMenuItem({
          activeMenuItem: 'MARKET:BOLSA:DETAILS:PROOF',
        }),
      );
    }
  };

  const tradeDataExistis = tradeData.length > 0;

  const selectedTitleExists = Object.keys(selectedTitle).length > 0;

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setTradeData([]);
    if (selectedTitleExists) {
      callService(
        selectedTitle.symbol,
        selectedTitle.exchange,
        selectedTitle.securityType,
      );
    }
  }, [selectedTitle, selectedTitleExists]);

  return (
    <Wraper>
      <Tables height="100%">
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled sx={{ textAlign: 'left', width: '70%' }}>
                <FormattedMessage id="TRLT_UI-DESCRIPTION" />
              </TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {!tradeDataExistis ? (
              <>
                <TableRowStyled>
                  <TableCellStyled sx={{ textAlign: 'left', width: '80%' }}>
                    <FormattedMessage id="TRLT_UI-NO_DOCUMENTS" />
                  </TableCellStyled>
                </TableRowStyled>
                {rows}
              </>
            ) : (
              <>
                {tradeData.map((el) => (
                  <TableRowStyled key={el.noteAttachId}>
                    <TableCellStyled sx={{ textAlign: 'left', width: '80%' }}>
                      <ButtonLink
                        variant="text"
                        onClick={() =>
                          openProofPreview(el.noteAttachId, el.fileName)
                        }
                      >
                        <FileIconStyled icon={faFileLines} />
                        {el.fileName}
                      </ButtonLink>
                    </TableCellStyled>
                  </TableRowStyled>
                ))}
                {rows}
              </>
            )}
          </TableBodyStyled>
        </TableStyled>
      </Tables>
    </Wraper>
  );
};

DocumentsList.propTypes = {
  isFunds: PropTypes.bool,
};
